<template>
  <div
    class="facet multi-facet"
    :class="{ error: !this.valid, required: facet.required }"
  >
    <h5>{{ facet.name }}</h5>

    <ul class="options">
      <li
        v-for="choice in choices"
        :class="classes(choice)"
        :key="choice.id"
        @click="toggle(choice)"
      >
        {{ choice.value }}

        <price-modifier :choice="choice"></price-modifier>
      </li>
    </ul>
  </div>
</template>

<script>
import { money } from 'src/utilities';
import ActsAsFacet from 'mixins/ActsAsFacet';
import Stash from 'src/stash';

export default {
  mixins: [ActsAsFacet],

  computed: {
    selected() {
      return this.state.preferences.filter(p => p.facet_id === this.facet.id);
    },

    choice_limit_reached() {
      return this.selected.length >= this.facet.choice_limit;
    },
  },

  methods: {
    isSelected(choice) {
      return this.selected.find(p => p.choice_id === choice.id) !== undefined;
    },

    toggle(choice) {
      if (this.isSelected(choice)) {
        Stash.removePreference(this.facet, choice);
      } else if (!this.choice_limit_reached) {
        Stash.addPreference(this.facet, choice);
      }
    },

    classes(choice) {
      const classes = [];

      if (this.isSelected(choice)) {
        classes.push('selected');
      } else if (this.choice_limit_reached) {
        classes.push('disabled');
      }

      return classes;
    },

    validate() {
      return (this.valid = !this.facet.required || this.selected.length > 0);
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// MultiFacet.vue?bd865a48